<template>
  <v-col cols="4" sm="4" md="4">
    <v-card class="mx-auto" height="135">
      <v-list-item three-line>
        <v-list-item-content>
          <div class="overline mb-4">
            TRASCRIZIONI
          </div>
          <v-list-item-title class="headline mb-1">
            Tot: <span v-if="totOrgTranscriptions">{{totOrgTranscriptions.data[0].tot}}</span> 
          </v-list-item-title>
          <v-list-item-subtitle>TotTime: <span v-if="totOrgTranscTime">{{totOrgTranscTime}}</span></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import { getOrgStats } from "../../plugins/getAnalysics";
import { formatSecondsToTime } from "../../plugins/timeFormat";

export default {
  name: "OrgDetailData",

  data() {
    return {
      totOrgTranscriptions: null,
      totOrgTranscTime: null,
    };
  },

  props: {
    orgId: {
      default: () => ({})
    },
    userId: {
      default: () => ({})
    },
  },

  computed: {
    ...mapGetters({
      datesrange: "datesrange",
    }),
  },

  methods: {
    async getTranscriptionsAnalytics(){

      const totOrgTranscriptions = await getOrgStats({ queryType: 'totTranscriptions', orgId: this.orgId, userId: this.userId, datesrange: this.datesrange })
      this.totOrgTranscriptions = totOrgTranscriptions

      const totOrgTranscTime = await getOrgStats({ queryType: 'totTranscTime', orgId: this.orgId, userId: this.userId, datesrange: this.datesrange })
      const totOrgTranscTimeFormatted = await formatSecondsToTime(totOrgTranscTime.data[0].tot)
      this.totOrgTranscTime = totOrgTranscTimeFormatted
    },
  },

  async mounted(){
    this.getTranscriptionsAnalytics();
  },

}
</script>

<style>

</style>